/* 🤖 this file was generated by svg-to-ts */
export const iconLink: {
  name: 'link';
  data: string;
} = {
  name: 'link',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#chainlink__clip0_297_158)"><path fill="#fff" d="M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16"/><path fill="#3659D1" d="m16.02 2.43-2.49 1.43-6.79 3.92-2.49 1.43v13.57l2.49 1.43 6.85 3.92 2.49 1.43 2.49-1.43 6.72-3.92 2.49-1.43V9.21l-2.49-1.43-6.79-3.92-2.49-1.43zm-6.78 17.5v-7.85l6.79-3.92 6.79 3.92v7.84l-6.79 3.92-6.79-3.92z"/></g><defs><clipPath id="chainlink__clip0_297_158"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
